export default __webpack_public_path__ + "static/media/maintainpage-workworkwork.931fe872.svg";